import { Box, Collapse, FormControlLabel, Stack, styled, Typography } from '@mui/material';

export const FullWidthBox = styled(Box)(() => ({
  width: '100%',
})) as typeof Box;

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
}));

export const CenteredStack = styled(Stack)(() => ({
  alignItems: 'center',
}));

export const FullHeightLayout = styled(Stack)(() => ({
  height: '100vh',
  justifyContent: 'space-between',
}));

export const ContentStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '445px',
  },
}));

export const WideContentStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '500px',
  },
}));

export const SubmitStack = styled(Stack)(() => ({
  width: '100%',
  marginTop: '20px !important',
}));

export const ButtonsStack = styled(Stack)(() => ({
  width: '100%',
  gap: '12px',
}));

export const FullWidthCollapse = styled(Collapse)(() => ({
  width: '100%',
}));

export const CenteredText = styled(Typography)(() => ({
  textAlign: 'center',
}));

export const CheckboxLabel = styled(FormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',
  marginLeft: 0,
  gap: theme.spacing(0.8),
}));

export const CheckboxLabelText = styled(Typography)(() => ({
  marginTop: '2px',
}));
